const countries = {
  selectCountry: 'Select a country'
};

export default countries;
